import { render, staticRenderFns } from "./BaseEditAbonent.vue?vue&type=template&id=b65db990&scoped=true"
import script from "./BaseEditAbonent.vue?vue&type=script&lang=js"
export * from "./BaseEditAbonent.vue?vue&type=script&lang=js"
import style0 from "./BaseEditAbonent.vue?vue&type=style&index=0&id=b65db990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65db990",
  null
  
)

export default component.exports